module.exports = __webpack_public_path__ + "static/media/15.0dd62cb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/15.jpg
// module id = 705
// module chunks = 0